import get from 'lodash/get';
import { PAYPAL_API_URLS } from './paypal-constants';
import { setSessionUrls, clearLocalStorage } from './paypal-utils';
import utils from 'public/js/helpers/utils';
import request from './request';

window.rp_app = rp_app || {};
/* eslint-disable-next-line  no-unused-vars */
const createOrder = (data, actions) => {
	//Clear Previous PayPal State If Set
	clearLocalStorage();
	if(window.tracking.google.use_gtag_admind_analytics && !rp_app.env.is_webstore_plugin && data.trigger_begin_checkout_event){
		window.rp_app.track.track_ec_general('begin_checkout', {
			currency:rp_app.cart._currency_code,
			items:utils.convertNamesOfItemsForGA(utils.getItemsFromRpappCart(rp_app.cart.cart))
		});
	}

	return request(PAYPAL_API_URLS.create, 'POST', data)
		.then((response) => {
			if (get(response, 'sessionUrls')) {
				setSessionUrls(get(response, 'sessionUrls'));
			}

			return get(response, 'token');
		}).catch(() => {
			return; // failed PayPal flow
		});
};

export default createOrder;
